<ion-loading [isOpen]="isRefreshing()" message="Mise à jour de la demande en cours..." />

@let prestation = demande();
@if (prestation) {
  <ion-card class="main-card">
    <ion-card-content>
      <div class="main-infos-wrapper">
        <h2>{{ 'listeDemandesRecues.detailsDemande.titreMainInfos' | translate: { client: prestation.clientLibelle } }}</h2>
        <p>
          {{ 'listeDemandesRecues.detailsDemande.envoyea' | translate: { time: (dateEmission() | date: 'HH:mm') } }}<br />
          {{ prestation.origine }}
        </p>
      </div>
      <hr />
      <div class="adresse-wrapper">
        <div>
          <p>{{ prestation.site?.adresse ?? '' | addressCommaToLineBreak }}</p>
          @if (distanceInMeters()) {
            <ion-note>
              <ion-text color="medium">
                {{
                  'listeDemandesRecues.detailsDemande.distance'
                    | translate: { formattedDistanceInKm: (distanceInMeters() ?? 0) / 1000 | number: '1.0-1' }
                }}
              </ion-text>
            </ion-note>
          }
        </div>
        <div class="map-button-wrapper">
          <ion-button
            size="medium"
            (click)="openMap(prestation.site?.location?.latitude ?? 0, prestation.site?.location?.longitude ?? 0, prestation.site?.adresse)"
          >
            <fa-icon [icon]="faMapMarkedAlt" class="ion-margin-right" />
            {{ 'listeDemandesRecues.voirPlan' | translate }}
          </ion-button>
        </div>
      </div>
      <hr />
      @if (prestation.origine) {
        <div>
          <span class="details-demande-header">Origine : </span>
          <span>{{ prestation.origine }}</span>
        </div>
      }

      @if (prestation.origineDetails) {
        <div>
          <span class="details-demande-header">Détails : </span>
          <span>
            {{ prestation.origineDetails }}
          </span>
        </div>
      }
      @if (prestation.origineDetails || prestation.origine) {
        <hr />
      }
      <div
        class="autorisation-penetrer-wrapper"
        [class.can-enter]="autorisationPenetrerInterieurBatiment()"
        [class.cannot-enter]="!autorisationPenetrerInterieurBatiment()"
      >
        @if (autorisationPenetrerInterieurBatiment()) {
          <div class="icon-wrapper">
            <fa-icon class="icon" [icon]="faCheck"></fa-icon>
          </div>
          {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerInterieurBatiment.oui' | translate }}
        } @else {
          <div class="icon-wrapper">
            <fa-icon class="icon" [icon]="faTimes"></fa-icon>
          </div>
          {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerInterieurBatiment.non' | translate }}
        }
      </div>
      @if (autorisationPenetrerEspacesExterieurCloture()) {
        <div
          class="autorisation-penetrer-wrapper"
          [class.can-enter]="autorisationPenetrerEspacesExterieurCloture()"
          [class.cannot-enter]="!autorisationPenetrerEspacesExterieurCloture()"
        >
          @if (autorisationPenetrerEspacesExterieurCloture()) {
            <div class="icon-wrapper">
              <fa-icon class="icon" [icon]="faCheck"></fa-icon>
            </div>
            {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerEspacesExterieurCloture.oui' | translate }}
          } @else {
            <div class="icon-wrapper">
              <fa-icon class="icon" [icon]="faTimes"></fa-icon>
            </div>
            {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerEspacesExterieurCloture.non' | translate }}
          }
        </div>
      }
      <div
        class="autorisation-penetrer-wrapper"
        [class.can-enter]="autorisationPenetrerEspacesCommun()"
        [class.cannot-enter]="!autorisationPenetrerEspacesCommun()"
      >
        @if (autorisationPenetrerEspacesCommun()) {
          <div class="icon-wrapper">
            <fa-icon class="icon" [icon]="faCheck"></fa-icon>
          </div>
          {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerEspacesCommun.oui' | translate }}
        } @else {
          <div class="icon-wrapper">
            <fa-icon class="icon" [icon]="faTimes"></fa-icon>
          </div>
          {{ 'listeDemandesRecues.detailsDemande.autorisationPenetrerEspacesCommun.non' | translate }}
        }
      </div>
    </ion-card-content>
  </ion-card>

  @if (prestation.precisions && prestation.precisions.length > 0) {
    <ion-card class="precisions-card">
      <ion-card-content>
        <div class="infos-wrapper">Information ajoutées par le client après le début de l'intervention :</div>
        @for (precision of prestation.precisions; track precision.instant) {
          <div>{{ precision.instant | date: 'HH:mm' }} : {{ precision.texte }}</div>
        }
      </ion-card-content>
    </ion-card>
  }

  @if ((prestation.precisionSite?.photos?.length ?? 0) > 0) {
    <div
      class="thumbnails-wrapper"
      [class.one-picture]="prestation.precisionSite?.photos?.length === 1"
      [class.multiple-pictures]="(prestation.precisionSite?.photos?.length ?? 0) > 1"
    >
      @if ((prestation.precisionSite?.photos?.length ?? 0) >= 1) {
        <img class="thumbnail1" (click)="openPictureModal(0)" alt="" [src]="prestation.precisionSite?.photos?.[0] ?? '' | safeUrl" />
      }
      @for (
        pic of prestation.precisionSite?.photos
          | slice
            : 1
            : ((prestation.precisionSite?.photos?.length ?? 0) - 1 > MAX_THUMBNAILS
                ? MAX_THUMBNAILS
                : (prestation.precisionSite?.photos?.length ?? 0));
        track pic;
        let i = $index
      ) {
        <ion-thumbnail [class]="'thumbnail' + (i + 2)" (click)="openPictureModal(i + 1)">
          <img alt="" [src]="pic | safeUrl" />
        </ion-thumbnail>
      }
      @if ((prestation.precisionSite?.photos?.length ?? 0) - 1 > MAX_THUMBNAILS) {
        <ion-button
          [class]="'more-pictures-button ion-no-margin thumbnail' + (MAX_THUMBNAILS + 1)"
          color="medium"
          (click)="openPictureModal(MAX_THUMBNAILS)"
        >
          +{{ (prestation.precisionSite?.photos?.length ?? 0) - MAX_THUMBNAILS }}
        </ion-button>
      }
    </div>
  }
  <ion-card>
    <ion-card-content class="details-lieu-container">
      <div slot="content">
        <ion-item>
          <ion-label class="details-lieu-header">Détails du lieu</ion-label>
        </ion-item>
        <ion-list>
          @let precision = prestation.precisionSite;
          @if (precision?.typeHabitation) {
            <ion-item>
              <ion-label>{{ 'listeDemandesRecues.detailsDemande.type' | translate }}</ion-label>
              <ion-label slot="end">{{ precision.typeHabitation | titlecase }}</ion-label>
            </ion-item>
          }
          @if (precision?.categorieHabitation) {
            <ion-item>
              <ion-label>{{ 'listeDemandesRecues.detailsDemande.categorieHabitation' | translate }}</ion-label>
              <ion-label slot="end">{{ precision.categorieHabitation | titlecase }}</ion-label>
            </ion-item>
          }
          @if (precision?.acces) {
            <ion-item>
              @if (shouldDisplayAcces()) {
                <ion-label>{{ 'listeDemandesRecues.detailsDemande.acces' | translate }}</ion-label>
                <ion-label slot="end">{{ precision.acces }}</ion-label>
              } @else {
                <ion-label>{{ 'listeDemandesRecues.detailsDemande.acces' | translate }}</ion-label>
                <ion-text color="info">
                  <fa-icon [icon]="faInfoCircle"></fa-icon>
                  {{ 'listeDemandesRecues.disponibleApresArrivee' | translate }}
                </ion-text>
              }
            </ion-item>
          }
          @if (precision?.animaux) {
            <div class="long-text">
              <p class="long-text-header">{{ 'listeDemandesRecues.detailsDemande.animaux' | translate }}</p>
              <p>{{ precision.animaux }}</p>
            </div>
          }
          @let protection = precision?.protectionSite;
          @if (protection && (protection.alarme || protection.cameraExterieure || protection.cameraInterieure || protection.autre)) {
            <div class="long-text">
              <p class="long-text-header">{{ 'listeDemandesRecues.detailsDemande.protectionLibelle' | translate }}</p>
              <p>
                @if (protection.alarme) {
                  {{ 'listeDemandesRecues.detailsDemande.protection.alarme' | translate }}
                }
                @if (protection.cameraInterieure) {
                  {{ 'listeDemandesRecues.detailsDemande.protection.cameraInterieure' | translate }}
                }
                @if (protection.cameraExterieure) {
                  {{ 'listeDemandesRecues.detailsDemande.protection.cameraExterieure' | translate }}
                }
                @if (protection.autre) {
                  {{ protection.autre }}
                }
              </p>
            </div>
          }
          @if (precision?.descriptionComplementaire) {
            <div class="long-text">
              <p class="long-text-header">{{ 'listeDemandesRecues.detailsDemande.descriptionComplementaire' | translate }}</p>
              <p>{{ precision.descriptionComplementaire }}</p>
            </div>
          }
          @if (precision?.etage) {
            <ion-item>
              <ion-label>{{ 'listeDemandesRecues.detailsDemande.etage' | translate }}</ion-label>
              <ion-label slot="end">{{ precision.etage }}</ion-label>
            </ion-item>
          }
        </ion-list>
      </div>
    </ion-card-content>
  </ion-card>
}
